export default "__VITE_ASSET__DsLBqKGK__"